<template>
  <div>
    <v-icon  class="mb-4 back-button" v-on:click="goBack"
      >mdi-arrow-left</v-icon
    >
  </div>
</template>

<script>
export default {
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.back-button {
  cursor: pointer;
  margin-left: -3px;
}
</style>
